/** Shared M2M setup copy for Entra connect surfaces (POST-ARC.8). */
export const ENTRA_PERMISSIONS_DOC_URL =
  "https://github.com/idaxis/idwiz/blob/main/docs/specs/ENTRA_GRAPH_PERMISSIONS.md";

export const ENTRA_M2M_GUIDANCE = `To connect your Microsoft Entra tenant, register an application with client credentials:

1. Microsoft Entra admin center → App registrations → New registration.
2. Note the Directory (tenant) ID and Application (client) ID.
3. Certificates & secrets → New client secret (copy the value once).
4. API permissions → Microsoft Graph → Application permissions — add:
   Application.Read.All, Directory.Read.All, RoleManagement.Read.Directory,
   Group.Read.All, Policy.Read.All, AuditLog.Read.All, Reports.Read.All, User.Read.All
   (optional: IdentityRiskyUser.Read.All for Identity Protection findings).
5. Grant admin consent for the tenant.

Paste tenant ID, client ID, and secret above, then click Test Connection.
We only read your configuration — no writes, no policy changes, no user data modifications.

Full permission reference: ${ENTRA_PERMISSIONS_DOC_URL}`;
